import {axiosInstanceWithToken}  from "../utils/Client";

export default class DailyAttendanceService {
    static getAttendanceSheet = (locationId) => {
        return axiosInstanceWithToken.get(`/timesheet/${locationId}/`);
    };

    static getAttendancePDF = (userId, startDate, endDate) => {
        let url = `/time_sheet/report/${userId}/?start_date=${startDate}&end_date=${endDate}`;
        return axiosInstanceWithToken.get(url);
    };

    static getTimesheetSummaryPDF = (locationId, startDate, endDate) => {
        let url = `/time_sheet_summary/report/all/${locationId}/?start_date=${startDate}&end_date=${endDate}`;
        return axiosInstanceWithToken.get(url);
    }

    static getAttendancePDFforAllStaff = (locationId, startDate, endDate) => {
        let url = `/time_sheet/report/all/${locationId}/?start_date=${startDate}&end_date=${endDate}`;
        return axiosInstanceWithToken.get(url);
    };

    static getUserTimeSheet = (userId, workDate) => {
        return axiosInstanceWithToken.get(`/timesheet/edit/${userId}/?work_date=${workDate}`);
    };

    static updateUserTimeSheet = (userId, workDate, timeSheet) => {
        return axiosInstanceWithToken.put(
            `/timesheet/edit/${userId}/?work_date=${workDate}`,
            timeSheet
        );
    };

    static saveUserTimeSheet = (userId, workDate, timeSheet) => {
        return axiosInstanceWithToken.post(
            `/timesheet/edit/${userId}/?work_date=${workDate}`,
            timeSheet
        );
    };

    static deleteUserTimeSheet = (timeSheetId) => {
        return axiosInstanceWithToken.delete(
            `/timesheet/delete/${timeSheetId}/`
        );
    };

    static getStaffList = (locationId) => {
        return axiosInstanceWithToken.get(`/staff/list/${locationId}/`);
    };

    static getReasons = (locationId) => {
        return axiosInstanceWithToken.get(`/clock_out_reason/${locationId}/`);
    };

    static getPeriodList = () => {
        return axiosInstanceWithToken.get(`/time_sheet/periods/`);
    };
}


// WEBPACK FOOTER //
// ./src/services/DailyAttendanceService.js